<!-- <cbc-container [isLoading]="isLoading" [showContainer]="!isLoading"
  [title]="searchConfig?.type == 'OFFERING' ? 'Resultado da Busca por Ofertas de Consultas e Procedimentos' : 'Resultado da Busca por Demandas de Consultas e Procedimentos'"
  description="Visualize os resultados encontrados para sua pesquisa">
</cbc-container> -->

@if(!isLoading) {
<div class="container">
  <div *ngIf="!isLoading">
    <div style="max-width: 1024px; text-align: left; width: 100%">
      
      <!-- View Mode Toggle -->
      <div class="view-mode-toggle">
        <button mat-icon-button 
                [class.active]="viewMode() === 'list'"
                (click)="viewModeService.setViewMode('list')"
                matTooltip="Visualização em Lista"
                aria-label="Modo de visualização em lista">
          <mat-icon>view_list</mat-icon>
        </button>
        <button mat-icon-button 
                [class.active]="viewMode() === 'grid'"
                (click)="viewModeService.setViewMode('grid')"
                matTooltip="Visualização em Grade"
                aria-label="Modo de visualização em grade">
          <mat-icon>view_module</mat-icon>
        </button>
        
        <!-- Export Button -->
        <button mat-raised-button 
                color="accent"
                (click)="openExportDialog()"
                [disabled]="!items || items.length === 0"
                class="export-button"
                matTooltip="Exportar resultados"
                aria-label="Exportar resultados da busca">
          <mat-icon>file_download</mat-icon>
          Exportar
        </button>
      </div>
      
      <!-- Floating Compare Button -->
      @if (canCompare()) {
        <div class="compare-fab-container">
          <button mat-fab 
                  extended 
                  color="primary" 
                  (click)="openComparison()"
                  class="compare-fab"
                  aria-label="Comparar itens selecionados">
            <mat-icon>compare_arrows</mat-icon>
            Comparar ({{ comparisonCount() }})
          </button>
          <button mat-mini-fab 
                  color="warn" 
                  (click)="clearComparison()"
                  class="clear-fab"
                  matTooltip="Limpar seleção"
                  aria-label="Limpar seleção de comparação">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      }

      <!-- List View (Accordion) -->
      @if (viewMode() === 'list') {
        <mat-accordion *ngIf="pagedItems && pagedItems.length > 0">
          <mat-expansion-panel *ngFor="let item of pagedItems; let i = index">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="comparison-checkbox-container">
                  <mat-checkbox 
                    [checked]="isItemSelected(item.id)"
                    (change)="toggleItemSelection(item, $event)"
                    [disabled]="isFull() && !isItemSelected(item.id)"
                    [matTooltip]="isFull() && !isItemSelected(item.id) ? 'Limite de comparação atingido (máximo 4 itens)' : 'Selecionar para comparação'"
                    aria-label="Selecionar item para comparação">
                  </mat-checkbox>
                </div>
                <div class="mat-panel-title-custom">
                  {{ item.id }} - {{ item.professionName }}<br />
                  <strong>Especialidade: </strong> {{ item.specialty }}<br />
                  <strong>Áreas de Atuação:</strong> {{ item.activityAreas }}
                </div>

                <div class="observationText">
                  <div>
                    <ng-container *ngIf="item.publicationDate; else notPublished">
                      Data da Publicação: {{ item.publicationDate | date : 'dd/MM/yyyy' }}
                      <ng-container *ngIf="item.expirationPublicationDate"> - Valido até: {{
                        item.expirationPublicationDate | date : 'dd/MM/yyyy' }}</ng-container>
                    </ng-container>
                    <ng-template #notPublished>Não Publicado</ng-template>
                  </div>
                  <div style="flex: 1 0 50px; place-self: self-end">
                    {{ item.status | enumDescription }}
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-panel-description style="flex-wrap: wrap">
              <div class="field-row">
                <span>Data da criação:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.creationDate | date : "dd/MM/yyyy '-' hh:mm" }}</strong>
              </div>

              <div class="field-row">
                <span>Atendimento à adulto:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.adultCare ? 'Sim' : 'Não' }}</strong>
              </div>

              <div class="field-row">
                <span>Atendimento pediátrico:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.pediatricCare ? 'Sim' : 'Não' }}</strong>
              </div>

              <div class="field-row">
                <span>Formato Online:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.serviceFormatOnLine ? 'Sim' : 'Não' }}</strong>
              </div>

              <div class="field-row">
                <span>Formato Presencial:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.serviceFormatPresential ? 'Sim' : 'Não' }}</strong>
              </div>

              <div class="field-row" *ngIf="item.address?.street">
                <span>Endereço:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.address?.street }}, {{ item.address?.number }} - {{ item.address?.city
                  }}/{{ item.address?.state }}</strong>
              </div>

              <div>
                Disponibilidade:
                <app-availability [availabilityShow]="item.availability"></app-availability>
              </div>

              <div class="field-row">
                <span>Valor Proposto:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.amount ? (item.amount | currency : 'BRL' : 'symbol' : '1.2-2') : '-'
                  }}</strong>
              </div>

              <div class="field-row" *ngIf="item.amount">
                <span>Unidade:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.billingUnit | enumDescription }}</strong>
              </div>

              <div class="field-row">
                <span>Descrição:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.description }}</strong>
              </div>

              <div class="field-row">
                <span>Status:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.status | enumDescription }}</strong>
              </div>

              <div class="field-row">
                <span>Atendimento plantonista:</span>
                <span class="field-dots"></span>
                <strong class="field-value">{{ item.emergencyService ? 'Sim' : 'Não' }}</strong>
              </div>

              <div>
                Disponibilidade Plantonista:
                <app-availability [availabilityShow]="item.emergencyServiceAvailability"></app-availability>
              </div>

              <div class="footerButtons">
                <div class="panel-footer">
                  <div class="actions">
                    <button mat-raised-button color="primary" (click)="createRegisterNegotiation(item.id)  ">
                      <mat-icon>speaker_notes</mat-icon>
                      <span>Convidar para negociar</span>
                    </button>
                  </div>
                </div>
              </div>
            </mat-panel-description>
          </mat-expansion-panel>
        </mat-accordion>
      }

      <!-- Grid View -->
      @if (viewMode() === 'grid') {
        <div class="grid-container" *ngIf="pagedItems && pagedItems.length > 0">
          <mat-card *ngFor="let item of pagedItems" class="result-card" [class.selected-for-comparison]="isItemSelected(item.id)">
            <div class="card-checkbox">
              <mat-checkbox 
                [checked]="isItemSelected(item.id)"
                (change)="toggleItemSelection(item, $event)"
                [disabled]="isFull() && !isItemSelected(item.id)"
                [matTooltip]="isFull() && !isItemSelected(item.id) ? 'Limite de comparação atingido (máximo 4 itens)' : 'Selecionar para comparação'"
                aria-label="Selecionar item para comparação">
              </mat-checkbox>
            </div>
            <mat-card-header>
              <mat-card-title>
                <div class="card-title-text">
                  {{ item.id }} - {{ item.professionName }}
                </div>
              </mat-card-title>
              <mat-card-subtitle>
                <strong>Especialidade:</strong> {{ item.specialty }}
              </mat-card-subtitle>
            </mat-card-header>
            
            <mat-card-content>
              <div class="card-field">
                <mat-icon class="field-icon">work</mat-icon>
                <span><strong>Áreas:</strong> {{ item.activityAreas }}</span>
              </div>

              <div class="card-field" *ngIf="item.address?.street">
                <mat-icon class="field-icon">location_on</mat-icon>
                <span>{{ item.address?.city }}/{{ item.address?.state }}</span>
              </div>

              <div class="card-field">
                <mat-icon class="field-icon">attach_money</mat-icon>
                <span>{{ item.amount ? (item.amount | currency : 'BRL' : 'symbol' : '1.2-2') : 'Não informado' }}</span>
              </div>

              <div class="card-field">
                <mat-icon class="field-icon">people</mat-icon>
                <span>
                  {{ item.adultCare ? 'Adulto' : '' }}
                  {{ item.adultCare && item.pediatricCare ? ' | ' : '' }}
                  {{ item.pediatricCare ? 'Pediátrico' : '' }}
                </span>
              </div>

              <div class="card-field">
                <mat-icon class="field-icon">computer</mat-icon>
                <span>
                  {{ item.serviceFormatOnLine ? 'Online' : '' }}
                  {{ item.serviceFormatOnLine && item.serviceFormatPresential ? ' | ' : '' }}
                  {{ item.serviceFormatPresential ? 'Presencial' : '' }}
                </span>
              </div>

              <div class="card-status">
                <mat-chip>{{ item.status | enumDescription }}</mat-chip>
              </div>
            </mat-card-content>

            <mat-card-actions>
              <button mat-raised-button color="primary" (click)="createRegisterNegotiation(item.id)">
                <mat-icon>speaker_notes</mat-icon>
                <span>Negociar</span>
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      }

      <div *ngIf="(!pagedItems || pagedItems.length === 0) && (items && items.length === 0)">
        <p>Nenhum resultado encontrado.</p>
      </div>

      <mat-paginator [length]="length || (items ? items.length : 0)" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </div>
</div>
}